var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Regular/Outline/Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.751 21.9399H13.498C13.084 21.9399 12.748 21.6039 12.748 21.1899C12.748 20.7759 13.084 20.4399 13.498 20.4399H20.751C21.165 20.4399 21.501 20.7759 21.501 21.1899C21.501 21.6039 21.165 21.9399 20.751 21.9399Z",
    fill: "#52C41A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1050_30764",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 18,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 3.00043H19.1811V21.94H2.00049V3.00043Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1050_30764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1108 5.01707L3.69576 16.7921C3.52476 17.0061 3.46176 17.2821 3.52476 17.5471L4.20576 20.4321L7.24476 20.3941C7.53376 20.3911 7.80076 20.2621 7.97776 20.0421C11.1948 16.0171 17.3278 8.34307 17.5018 8.11807C17.6658 7.85207 17.7298 7.47607 17.6438 7.11407C17.5558 6.74307 17.3248 6.42807 16.9918 6.22707C16.9208 6.17807 15.2358 4.87007 15.1838 4.82907C14.5498 4.32107 13.6248 4.40907 13.1108 5.01707ZM3.61376 21.9401C3.26676 21.9401 2.96476 21.7021 2.88376 21.3631L2.06476 17.8921C1.89576 17.1731 2.06376 16.4311 2.52476 15.8551L11.9448 4.07307C11.9488 4.06907 11.9518 4.06407 11.9558 4.06007C12.9888 2.82507 14.8568 2.64307 16.1168 3.65407C16.1668 3.69307 17.8398 4.99307 17.8398 4.99307C18.4478 5.35507 18.9228 6.00207 19.1028 6.76807C19.2818 7.52607 19.1518 8.30807 18.7348 8.96907C18.7038 9.01807 18.6768 9.06007 9.14876 20.9801C8.68976 21.5521 8.00176 21.8851 7.26276 21.8941L3.62376 21.9401H3.61376Z",
    fill: "#52C41A"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2234 11.6851C16.0634 11.6851 15.9034 11.6341 15.7664 11.5301L10.3144 7.34205C9.98642 7.09005 9.92442 6.62005 10.1764 6.29005C10.4294 5.96205 10.8994 5.90105 11.2284 6.15305L16.6814 10.3401C17.0094 10.5921 17.0714 11.0631 16.8184 11.3921C16.6714 11.5841 16.4484 11.6851 16.2234 11.6851Z",
    fill: "#52C41A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileEdit);
export default __webpack_public_path__ + "static/media/icon-file-edit.80fa9a5954120340ef2a81255184c5a3.svg";
export { ForwardRef as ReactComponent };